import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Student testimonials" className="bg-ink" data-id="element-167" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" data-id="element-168" data-mp="3fycrjpy4ubcd">
        <h2 className="text-center font-display text-2xl font-black text-white sm:text-3xl" data-id="element-169" data-mp="3b0kn5wgawwra">
          ⭐ Real Students. Real Results.
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-170" data-mp="36zqyh0v1bdxc">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-171" data-mp="321z8wdhv43wb" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}